import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DeliveryZone } from "../../common.types";
import { requestGetDeliveryZones } from "./getDeliveryZones.request";

const useGetDeliveryZones = (
  options?: QueryOptions<DeliveryZone[], ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["deliveryZones", "admin", "all"],
    queryFn: async () => await requestGetDeliveryZones(),
    onError: toastServerError,
    ...options
  });

  return { deliveryZones: data, ...rest };
};

export default useGetDeliveryZones;
